__turbopack_context__.v({
  "header": "QPdvAq_header",
  "link": "QPdvAq_link",
  "title": "QPdvAq_title",
});
